import {updatePassword} from '../api/updatePassword';

const setUpdatePassword = (params) => {
    return async (dispatch, getState) => {
        try {
            await updatePassword(params);

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setUpdatePassword
}